import { render, staticRenderFns } from "./selfCar.vue?vue&type=template&id=70c1a363&scoped=true&"
import script from "./selfCar.vue?vue&type=script&lang=js&"
export * from "./selfCar.vue?vue&type=script&lang=js&"
import style0 from "./selfCar.vue?vue&type=style&index=0&id=70c1a363&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1a363",
  null
  
)

export default component.exports